module.exports = __webpack_public_path__ + "img/index-solutions-sim-hover.8f41c462.png";